import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Selectors from '../selectors';
import CongratulationPresentational from './congratulationPresentational';
import Actions from '../action';
import { API_DOMAIN } from '@constants/app-constants';
import axios from 'axios';

const CongratulationFunctional = ({ getCompanyInfoCongratulatStart, companyInfoCangratulationData }) => {
	useEffect(() => {
		getCompanyInfoCongratulatStart();
	}, []);

	const [employeeFileLoading, setEmployeeFile] = useState(false);

	async function getEmployeeTempletStart(method, responseType) {
		return axios.request({ url: `${API_DOMAIN}/FileTemplate/Employee/Download`, method, responseType });
	}
	const getEmployeeTempletURL = () => {
		setEmployeeFile(true);
		getEmployeeTempletStart('GET', 'blob').then(({ data }) => {
			const downloadUrl = window.URL.createObjectURL(new Blob([data], { type: data.type }));
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.setAttribute('download', 'employee.xls'); //any other extension
			document.body.appendChild(link);
			link.click();
			link.remove();
			setEmployeeFile(false);
		});
	}
	return (
		<>
			<CongratulationPresentational
				employeeFileLoading={employeeFileLoading}
				getEmployeeTempletStart={getEmployeeTempletURL}
				companyInfoCangratulationData={companyInfoCangratulationData}
			></CongratulationPresentational>
		</>
	);
};
const mapStateToProps = (state) => {
	return {
		companyInfoCangratulationData: Selectors.companyInfoCangratulationData(state)
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getCompanyInfoCongratulatStart: () => dispatch(Actions.creators.getCompanyInfoCongratulatStart()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(CongratulationFunctional);
export default Connected;
